
import { computed, defineComponent, nextTick, onMounted, ref } from "vue";
import ViewHeader from "@/components/ViewHeader.vue";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import DropdownInput from "@/components/Inputs/DropdownInput.vue";
import TotalRow from "@/components/TotalRow.vue";
import { useStore } from "@/store";
import { BankTransferPayment } from "@/models/Order";
import { useRouter } from "vue-router";
import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import NumberInput from "@/components/Inputs/NumberInput.vue";
import TextInput from "@/components/Inputs/TextInput.vue";
import DateInput from "@/components/Inputs/DateInput.vue";
import useVuelidate from "@vuelidate/core";
import { required, minValue, not, sameAs } from "@vuelidate/validators";
import { Validation } from "@/models/Validation";
import mixin from "@/mixin";
import _ from "lodash";

export default defineComponent({
  components: {
    ViewHeader,
    BackAndCancelFooter,
    DropdownInput,
    TotalRow,
    DateInput,
    NumberInput,
    TextInput,
  },
  props: {
    paymentIndex: {
      type: Number,
    },
  },
  async setup(props) {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const currencies = computed(() =>
      store.state.currencies.map((x) => {
        return { id: x.id, name: x.symbol };
      })
    );
    const banks = computed(() => store.state.banks);
    const accounts = computed(() => store.state.accounts);
    const orderTotal = computed(() => store.getters.orderTotal);
    const canEditRate = computed(() => store.getters.canEditRate);
    const localCurrencyId = computed(() => store.state.localCurrencyId);

    const p = new BankTransferPayment();
    const payment =
      props.paymentIndex != undefined
        ? computed(
          () =>
            store.state.order.payment.bankTransferPayments.find(
              (x) => x.index == props.paymentIndex
            ) ?? new BankTransferPayment()
        )
        : ref(p);
    const orderPayment = computed(() => store.state.order.payment);
    if (props.paymentIndex == undefined) {
      payment.value.amount =
        store.getters.orderBalance > 0 ? store.getters.orderBalance : 1;
      payment.value.currencyId = 1;
      payment.value.localCurrencyRate =
        store.state.currencyRates.find(
          (x) => x.currencyId == payment.value.currencyId
        )?.rate ?? 1;
    }
    const total = computed(() =>
      payment.value.amount * payment.value.localCurrencyRate
    );

    onMounted(() => {
      nextTick(() => focusNext([0]));
    });

    function focusNext(indexes: number[]) {
      setTimeout(() => {
        for (const index of indexes) {
          const el = document.querySelector(`[data-index="${index + 1}"]`);
          console.log(el);
          if (el instanceof HTMLElement) {
            el.focus();
            return;
          }
        }
      },200)
    }

    const submitForm = async (event) => {
      const valid = await v.value.$validate();
      if (!valid) {
        event.preventDefault();
        event.stopPropagation();
        swal.fire({
          icon: "info",
          text: t("alert.pleaseFillAllRequiredFields"),
        });
      } else {
        if (props.paymentIndex == undefined) {
          store.state.order.payment.addPayment(payment.value);
        }
        router.back();
      }
    };

    function changeCurrency(e) {
      payment.value.currencyId = e.value;
      payment.value.localCurrencyRate =
        store.state.currencyRates.find((x) => x.currencyId == e.value)?.rate ??
        1;

        nextTick(() => focusNext([6, 7]));
    }
    const minBankId = _.minBy(banks.value, (x) => x.id)?.id ?? Number.MAX_VALUE;
    const rules = {
      bankId: { required, minValue: minValue(minBankId) },
      bankBranchNumber: { required, minValue: minValue(1) },
      receivingAccount: { required },
      accountNumber: { required },
      valueDate: { required },
      amount: { required, not: not(sameAs(0)) },
      currencyId: { required },
      localCurrencyRate: { required },
    };

    const scope = "validationScope";
    const validation = new Validation(rules, scope);

    const v = useVuelidate({ $scope: scope });

    return {
      currencies,
      total,
      accounts,
      payment,
      submitForm,
      changeCurrency,
      orderTotal,
      orderPayment,
      banks,
      v,
      validation,
      canEditRate,
      localCurrencyId,
      focusNext
    };
  },
});
